<script>
import { onMount } from "svelte";

const STORAGE_KEY = "sarnolot-theme";

let theme = "light";

const read = () => {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch (error) {
        return null;
    }
};

const toggle = () => {
    theme = theme === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", theme);

    try {
        localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {
        /* brak dostępu do localStorage nie może zepsuć przełącznika */
    }
};

onMount(() => {
    const stored = read();

    theme = stored || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
});
</script>

<button class="theme-toggle" on:click={toggle}
    title={theme === "dark" ? "Przełącz na motyw jasny" : "Przełącz na motyw ciemny"}
    aria-label={theme === "dark" ? "Przełącz na motyw jasny" : "Przełącz na motyw ciemny"}>
    {#if theme === "dark"}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4"/>
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
        </svg>
    {:else}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/>
        </svg>
    {/if}
</button>
